const { vec4 } = require('glov/common/vmath.js');
const { spritesheetRegister } = require('glov/client/spritesheet.js');
module.exports = {
  name: 'space',
  tiles: {
    asteroid: 0,
    asteroid_empty: 1,
    core: 2,
    enemy1: 3,
    enemy2: 4,
    factory: 5,
    factory_building: 6,
    factory_empty: 7,
    factory_ready: 8,
    fighter: 9,
    fighterbay: 10,
    fighterbay_building: 11,
    fighterbay_empty: 12,
    generator: 13,
    laser: 14,
    laser_building: 15,
    laser_empty: 16,
    miner: 17,
    miner_building: 18,
    minerdone: 19,
    minerul: 20,
    minerup: 21,
    music_off: 22,
    music_on: 23,
    router: 24,
    router_building: 25,
    sound_off: 26,
    sound_on: 27,
    speed_ff: 28,
    speed_play: 29,
    supply: 30
  },
  uidata: {
    rects: [
      vec4(0,0,0.025390625,0.8125),
      vec4(0.025390625,0,0.05078125,0.8125),
      vec4(0.05078125,0,0.076171875,0.8125),
      vec4(0.076171875,0,0.1015625,0.8125),
      vec4(0.1015625,0,0.126953125,0.8125),
      vec4(0.126953125,0,0.15234375,0.8125),
      vec4(0.15234375,0,0.177734375,0.8125),
      vec4(0.177734375,0,0.203125,0.8125),
      vec4(0.203125,0,0.228515625,0.8125),
      vec4(0.228515625,0,0.25390625,0.8125),
      vec4(0.25390625,0,0.283203125,0.9375),
      vec4(0.283203125,0,0.3125,0.9375),
      vec4(0.3125,0,0.341796875,0.9375),
      vec4(0.341796875,0,0.3671875,0.8125),
      vec4(0.3671875,0,0.392578125,0.8125),
      vec4(0.392578125,0,0.41796875,0.8125),
      vec4(0.41796875,0,0.443359375,0.8125),
      vec4(0.443359375,0,0.46875,0.8125),
      vec4(0.46875,0,0.494140625,0.8125),
      vec4(0.494140625,0,0.51953125,0.8125),
      vec4(0.51953125,0,0.544921875,0.8125),
      vec4(0.544921875,0,0.5703125,0.8125),
      vec4(0.5703125,0,0.599609375,0.9375),
      vec4(0.599609375,0,0.62890625,0.9375),
      vec4(0.62890625,0,0.654296875,0.8125),
      vec4(0.654296875,0,0.6796875,0.8125),
      vec4(0.6796875,0,0.708984375,0.9375),
      vec4(0.708984375,0,0.73828125,0.9375),
      vec4(0.73828125,0,0.767578125,0.9375),
      vec4(0.767578125,0,0.796875,0.9375),
      vec4(0.796875,0,0.806640625,0.3125)
    ]
  },
  layers: undefined,
  FRAME_ASTEROID: 0,
  FRAME_ASTEROID_EMPTY: 1,
  FRAME_CORE: 2,
  FRAME_ENEMY1: 3,
  FRAME_ENEMY2: 4,
  FRAME_FACTORY: 5,
  FRAME_FACTORY_BUILDING: 6,
  FRAME_FACTORY_EMPTY: 7,
  FRAME_FACTORY_READY: 8,
  FRAME_FIGHTER: 9,
  FRAME_FIGHTERBAY: 10,
  FRAME_FIGHTERBAY_BUILDING: 11,
  FRAME_FIGHTERBAY_EMPTY: 12,
  FRAME_GENERATOR: 13,
  FRAME_LASER: 14,
  FRAME_LASER_BUILDING: 15,
  FRAME_LASER_EMPTY: 16,
  FRAME_MINER: 17,
  FRAME_MINER_BUILDING: 18,
  FRAME_MINERDONE: 19,
  FRAME_MINERUL: 20,
  FRAME_MINERUP: 21,
  FRAME_MUSIC_OFF: 22,
  FRAME_MUSIC_ON: 23,
  FRAME_ROUTER: 24,
  FRAME_ROUTER_BUILDING: 25,
  FRAME_SOUND_OFF: 26,
  FRAME_SOUND_ON: 27,
  FRAME_SPEED_FF: 28,
  FRAME_SPEED_PLAY: 29,
  FRAME_SUPPLY: 30
};
spritesheetRegister(module.exports);
